/**
 * Version configuration for the UI application
 * These values are injected at build time from environment variables
 */

export const UI_VERSION = process.env.REACT_APP_VERSION || '0.0.0';
export const UI_GIT_SHA = process.env.REACT_APP_GIT_SHA || 'local';

/**
 * API Version response type
 */
export interface ApiVersionInfo {
  version: string;
  fullVersion: string;
  buildDate: string;
  gitCommit: string | null;
  environment: string;
}

/**
 * Get the full UI version string including git sha
 */
export function getUIVersionString(): string {
  if (UI_GIT_SHA && UI_GIT_SHA !== 'local') {
    return `${UI_VERSION}+${UI_GIT_SHA}`;
  }
  return UI_VERSION;
}
